export enum MeterInventoryType
{
    Customer = 1,
    Asset = 2,
    Ctvt = 3
}
